module.exports = __webpack_public_path__ + "static/img/tery_icon03.437ef53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/tery_icon03.png
// module id = Rj+z
// module chunks = 1